export default {

  Title: 'Περιοχές',

  Table: {
    Headers: {
      Id     : '#',
      Name   : 'ΠΟΛΗ',
      County : 'ΝΟΜΟΣ',
      Actions: ''
    }
  },

  Form: {
    Title : 'Περιοχής',
    Fields: {
      Name  : { Label: 'Πόλη', Hint: '' },
      County: {
        Label: 'Νομός',
        Hint : ''
      }
    }
  },

  Button: {
    New: 'Νέα Περιοχή'
  }

}
